import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, Clock } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { RevealLines } from "@/components/Reveal";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-24 grid md:grid-cols-12 gap-16">
      <div className="md:col-span-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C3A3A] mb-5">We're Here</p>
        <h1 className="font-serif font-light text-6xl md:text-7xl tracking-tight text-[#1A1A1A] leading-[0.9]">
          <RevealLines lines={["Customer", "Service"]} />
        </h1>
        <p className="font-sans text-[15px] text-[#595959] leading-relaxed mt-8">
          Questions about sizing, orders, or refunds? Our team responds within 24 hours.
        </p>
        <div className="mt-12 space-y-6">
          {[[Mail, "anhadcollection.care@gmail.com"], [Phone, "+91 81686 45249"], [Clock, "Mon–Sat · 10am – 7pm IST"]].map(([Icon, t], i) => (
            <div key={i} className="flex items-center gap-4">
              <Icon size={18} className="text-[#8C3A3A]" />
              <span className="font-sans text-sm text-[#1A1A1A]">{t}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="md:col-span-6 md:col-start-7">
        <form onSubmit={submit} className="space-y-6 border border-[#E5E1D8] p-8 md:p-10" data-testid="contact-form">
          {[["Name", "name", "text"], ["Email", "email", "email"], ["Subject", "subject", "text"]].map(([label, key, type]) => (
            <label key={key} className="block">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">{label}</span>
              <input data-testid={`contact-${key}`} type={type} required={key !== "subject"} value={form[key]} onChange={set(key)} className="mt-2 w-full bg-transparent border border-[#E5E1D8] rounded-none px-4 py-3 font-sans text-sm focus:border-[#1A1A1A] outline-none transition-colors" />
            </label>
          ))}
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">Message</span>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={set("message")} className="mt-2 w-full bg-transparent border border-[#E5E1D8] rounded-none px-4 py-3 font-sans text-sm focus:border-[#1A1A1A] outline-none transition-colors resize-none" />
          </label>
          <button type="submit" disabled={loading} data-testid="contact-submit" className="w-full bg-[#1A1A1A] text-[#F9F8F6] py-4 font-mono text-[11px] uppercase tracking-[0.25em] hover:bg-[#8C3A3A] transition-colors disabled:opacity-50">
            {loading ? "Sending…" : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
